export default __webpack_public_path__ + "static/media/ic_wbnb_30.f3ea5930.svg";